var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadgeCircle } from '@backrs_ui/common-ui/src/atoms/BadgeCircle';
import { Box, Typography, Skeleton } from '@mui/material';
import ReactMarkdown from 'react-markdown';
export var BASE_NUGGET_HEIGHT = '367px';
export var BASE_NUGGET_WIDTH = '286px';
export var BASE_NUGGET_IMAGE_MAX_HEIGHT = '160px';
export var BaseNugget = function (_a) {
    var children = _a.children, subText = _a.subText, _b = _a.fitContent, fitContent = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.isLoadingSubText, isLoadingSubText = _c === void 0 ? false : _c, _d = _a.forceSubtextAtBottom, forceSubtextAtBottom = _d === void 0 ? false : _d, _e = _a.isHighlighted, isHighlighted = _e === void 0 ? false : _e;
    return (_jsxs(Box, { sx: containerSx(fitContent, forceSubtextAtBottom), onClick: onClick, children: [_jsx(Box, { sx: subcontainerSx(fitContent, isHighlighted), children: children }), (subText || (isLoadingSubText && subText !== '')) && (_jsxs(Box, { sx: subTextContainerSx(fitContent, forceSubtextAtBottom), children: [_jsx(Box, { mt: 0.5, children: _jsx(BadgeCircle, { loading: isLoadingSubText, size: "md" }) }), _jsx(Box, { sx: subTextSx, children: isLoadingSubText ? (_jsxs(Box, { sx: subTextSkeletonSx, children: [_jsx(Skeleton, { variant: "text", width: "100%", height: 20 }), _jsx(Skeleton, { variant: "text", width: "80%", height: 20 })] })) : (_jsx(ReactMarkdown, { components: {
                                p: function (_a) {
                                    var children = _a.children;
                                    return (_jsx(Typography, { component: "p", variant: "text-sm-regular", sx: { margin: 0 }, children: children }));
                                },
                            }, children: subText })) })] }))] }));
};
var containerSx = function (fitContent, forceSubtextAtBottom) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'column', height: fitContent || forceSubtextAtBottom ? 'fit-content' : BASE_NUGGET_HEIGHT, maxWidth: fitContent || forceSubtextAtBottom ? 'unset' : BASE_NUGGET_WIDTH, width: '100%', columnGap: backrs.spacing['spacing-3xl'], rowGap: backrs.spacing['spacing-md'], cursor: 'pointer' }, (fitContent &&
            !forceSubtextAtBottom && {
            '@media (min-width: 1100px)': {
                flexDirection: 'row',
                maxWidth: 'unset',
                width: '100%',
            },
        })));
    };
};
var subcontainerSx = function (fitContent, isHighlighted) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'column', width: '100%', height: fitContent ? 'fit-content' : BASE_NUGGET_HEIGHT, borderRadius: backrs.radius['radius-4xl'], backgroundColor: backrs.colors['Colors/Background/bg-primary'], border: "1px solid ".concat(isHighlighted ? backrs.colors['Brand/300'] : backrs.colors['Colors/Base/Black']), padding: backrs.spacing['spacing-xl'], overflow: 'hidden' }, (isHighlighted && {
            outline: "2px solid ".concat(backrs.colors['Brand/500']),
            outlineOffset: '2px',
        })));
    };
};
var subTextContainerSx = function (fitContent, forceSubtextAtBottom) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'column', height: 'fit-content', gap: backrs.spacing['spacing-md'], px: backrs.spacing['spacing-xl'], py: backrs.spacing['spacing-md'], backgroundColor: backrs.colors['Colors/Background/bg-secondary'], border: "1px solid ".concat(backrs.colors['Gray/900']), alignItems: 'flex-start', width: '100%', borderRadius: "0 ".concat(backrs.radius['radius-xl'], " ").concat(backrs.radius['radius-xl'], " ").concat(backrs.radius['radius-xl']) }, (fitContent &&
            !forceSubtextAtBottom && {
            '@media (min-width: 1300px)': {
                width: '50%',
            },
            '@media (min-width: 1450px)': {
                width: '75%',
            },
            '@media (min-width: 1600px)': {
                width: '100%',
            },
        })));
    };
};
var subTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        boxSizing: 'border-box',
        color: backrs.colors['Gray/900'],
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-md'],
        lineHeight: 1.5,
    });
};
var subTextSkeletonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xxs'],
    });
};
